import { render, staticRenderFns } from "./ContentMore.vue?vue&type=template&id=30f800b0"
import script from "./ContentMore.vue?vue&type=script&lang=js"
export * from "./ContentMore.vue?vue&type=script&lang=js"
import style0 from "./ContentMore.vue?vue&type=style&index=0&id=30f800b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports